<template>
  <div class="page">
    <div class="left" :class="{ 'is-collapsed': isCollapsed }">
      <div class="logo-section">
        <img src="@/assets/img/bg_logo.png" class="logo-img" />
        <span class="logo-text" v-show="!isCollapsed">数刷刷智慧数学平台</span>
      </div>
      <div class="nav-menu">
        <el-tooltip
          effect="dark"
          content="我的考试"
          placement="right"
          :disabled="!isCollapsed"
        >
          <div
            class="item"
            :class="{ active: isActive('/examination') }"
            @click="goRoute('/examination')"
          >
            <i class="el-icon-s-platform"></i>
            <span v-show="!isCollapsed">我的考试</span>
          </div>
        </el-tooltip>
        <el-tooltip
          effect="dark"
          content="自我测试"
          placement="right"
          :disabled="!isCollapsed"
        >
          <div
            class="item"
            :class="{ active: isActive('/bist'), 'disabled-item': hasExam }"
            @click="goRoute('/bist')"
          >
            <i class="el-icon-s-claim"></i>
            <span v-show="!isCollapsed">自我测试</span>
          </div>
        </el-tooltip>
        <el-tooltip
          effect="dark"
          content="我的作业"
          placement="right"
          :disabled="!isCollapsed"
        >
          <div
            class="item"
            :class="{ active: isActive('/task'), 'disabled-item': hasExam }"
            @click="goRoute('/task')"
          >
            <i class="el-icon-s-order"></i>
            <span v-show="!isCollapsed">我的作业</span>
          </div>
        </el-tooltip>
        <el-tooltip
          effect="dark"
          content="课堂练习"
          placement="right"
          :disabled="!isCollapsed"
        >
          <div
            class="item"
            :class="{ active: isActive('/practice'), 'disabled-item': hasExam }"
            @click="goRoute('/practice')"
          >
            <i class="el-icon-s-management"></i>
            <span v-show="!isCollapsed">课堂练习</span>
          </div>
        </el-tooltip>
        <el-tooltip
          effect="dark"
          content="课后小测"
          placement="right"
          :disabled="!isCollapsed"
        >
          <div
            class="item"
            :class="{ active: isActive('/classTest'), 'disabled-item': hasExam }"
            @click="goRoute('/classTest')"
          >
            <i class="el-icon-notebook-1"></i>
            <span v-show="!isCollapsed">课后小测</span>
          </div>
        </el-tooltip>
        <el-tooltip
          effect="dark"
          content="刷题房"
          placement="right"
          :disabled="!isCollapsed"
        >
          <div
            class="item"
            :class="{ active: isActive('/questions'), 'disabled-item': hasExam }"
            @click="goRoute('/questions')"
          >
            <i class="el-icon-document"></i>
            <span v-show="!isCollapsed">刷题房</span>
          </div>
        </el-tooltip>
        <!-- 高职数学竞赛（一级菜单 + 展开折叠子菜单） -->
        <div class="menu-group" :class="{ 'is-open': competitionExpanded }">
          <el-tooltip
            effect="dark"
            content="高职数学竞赛"
            placement="right"
            :disabled="!isCollapsed"
          >
            <div
              class="item parent-item"
              :class="{
                'group-active': isCompetitionActive,
                'disabled-item': hasExam
              }"
              @click="toggleCompetitionMenu"
            >
              <i class="el-icon-trophy"></i>
              <span v-show="!isCollapsed" class="parent-label">高职数学竞赛</span>
              <i
                v-show="!isCollapsed"
                class="arrow-icon el-icon-arrow-down"
                :class="{ 'is-rotated': competitionExpanded }"
              ></i>
            </div>
          </el-tooltip>
          <div
            class="sub-menu-list"
            v-show="!isCollapsed && competitionExpanded"
          >
            <div
              class="item sub-item"
              :class="{
                active: isActive('/practiceQuestions'),
                'disabled-item': hasExam
              }"
              @click="goRoute('/practiceQuestions')"
            >
              <i class="el-icon-edit-outline"></i>
              <span>练习题</span>
            </div>
            <div
              class="item sub-item"
              :class="{
                active: isActive('/classicQuestions'),
                'disabled-item': hasExam
              }"
              @click="goRoute('/classicQuestions')"
            >
              <i class="el-icon-collection"></i>
              <span>经典题</span>
            </div>
          </div>
        </div>
        <el-tooltip
          effect="dark"
          content="错题房"
          placement="right"
          :disabled="!isCollapsed"
        >
          <div
            class="item"
            :class="{ active: isActive('/errQuestions'), 'disabled-item': hasExam }"
            @click="goRoute('/errQuestions')"
          >
            <i class="el-icon-s-release"></i>
            <span v-show="!isCollapsed">错题房</span>
          </div>
        </el-tooltip>
        <el-tooltip
          effect="dark"
          content="学情画像"
          placement="right"
          :disabled="!isCollapsed"
        >
          <div
            class="item"
            :class="{ active: isActive('/portrait'), 'disabled-item': hasExam }"
            @click="goRoute('/portrait')"
          >
            <i class="el-icon-s-data"></i>
            <span v-show="!isCollapsed">学情画像</span>
          </div>
        </el-tooltip>
        <el-tooltip
          effect="dark"
          content="个人中心"
          placement="right"
          :disabled="!isCollapsed"
        >
          <div
            class="item"
            :class="{ active: isActive('/user'), 'disabled-item': hasExam }"
            @click="goRoute('/user')"
          >
            <i class="el-icon-s-custom"></i>
            <span v-show="!isCollapsed">个人中心</span>
          </div>
        </el-tooltip>
        <el-tooltip
          effect="dark"
          content="我的消息"
          placement="right"
          :disabled="!isCollapsed"
        >
          <div
            class="item"
            :class="{ active: isActive('/notice'), 'disabled-item': hasExam }"
            @click="goRoute('/notice')"
          >
            <!-- 折叠时：显示带提醒的图标 -->
            <el-badge
              v-if="isCollapsed"
              :value="unreadCount"
              :hidden="unreadCount <= 0"
              class="badge-item"
            >
              <i class="el-icon-message-solid"></i>
            </el-badge>
            <!-- 展开时：显示图标、文字和数字 -->
            <template v-else>
              <i class="el-icon-message-solid"></i>
              <span>我的消息</span>
              <el-badge
                :value="unreadCount"
                :hidden="unreadCount <= 0"
                class="badge-after"
              ></el-badge>
            </template>
          </div>
        </el-tooltip>
        <el-tooltip
          effect="dark"
          content="智慧数学课程"
          placement="right"
          :disabled="!isCollapsed"
        >
          <div
            class="item"
            :class="{ active: isActive('/bookCourse'), 'disabled-item': hasExam }"
            @click="goRoute('/bookCourse')"
          >
            <i class="el-icon-reading"></i>
            <span v-show="!isCollapsed">智慧数学课程</span>
          </div>
        </el-tooltip>
        <el-tooltip
          effect="dark"
          content="退出登录"
          placement="right"
          :disabled="!isCollapsed"
        >
          <div class="item logout-item" @click="logout">
            <i class="el-icon-switch-button"></i>
            <span v-show="!isCollapsed">退出登录</span>
          </div>
        </el-tooltip>
      </div>

      <div class="sidebar-footer">
        <div class="sidebar-user" v-show="!isCollapsed">
          <div class="user-avatar">
            {{ displayUserName ? displayUserName.substring(0, 1) : "U" }}
          </div>
          <div class="user-info">
            <div class="user-name">{{ displayUserName || "未知用户" }}</div>
            <div class="user-no">{{ displayUserNo }}</div>
          </div>
        </div>
        <div class="collapse-btn" @click="isCollapsed = !isCollapsed">
          <i :class="isCollapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
        </div>
      </div>
    </div>
    <div class="right">
      <transition name="fade-slide" mode="out-in">
        <div class="shell-content" :key="$route.fullPath">
          <router-view />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { getStudentInfo, hasExamination } from "@/api/student";

export default {
  name: "StudentShell",
  data() {
    return {
      isCollapsed: false,
      infoList: {},
      localSessionInfo: {},
      unreadCount: 0,
      timer: null,
      examTimer: null,
      hasExam: false,
      competitionExpanded: false
    };
  },
  computed: {
    displayUserName() {
      return (
        this.infoList.studentName ||
        this.infoList.name ||
        this.localSessionInfo.studentName ||
        this.localSessionInfo.name ||
        ""
      );
    },
    displayUserNo() {
      return (
        this.infoList.studentNo ||
        this.infoList.studentno ||
        this.localSessionInfo.studentNo ||
        this.localSessionInfo.studentno ||
        ""
      );
    },
    isCompetitionActive() {
      const p = this.$route.path;
      return p === "/practiceQuestions" || p === "/classicQuestions";
    }
  },
  created() {
    this.loadStudentInfo();
    this.fetchUnreadCount();
    this.timer = setInterval(this.fetchUnreadCount, 30000); // 30秒轮询一次
    this.$root.$on("refresh-unread-count", this.fetchUnreadCount);
    
    // 获取并设置当前考试状态
    this.checkExamStatus();
    this.examTimer = setInterval(this.checkExamStatus, 15000); // 15秒轮询一次
    if (this.isCompetitionActive) {
      this.competitionExpanded = true;
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        if (this.isCompetitionActive) {
          this.competitionExpanded = true;
        }
      }
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.examTimer) {
      clearInterval(this.examTimer);
    }
    this.$root.$off("refresh-unread-count");
  },
  methods: {
    toggleCompetitionMenu() {
      if (this.isCollapsed) {
        this.isCollapsed = false;
        this.competitionExpanded = true;
        return;
      }
      this.competitionExpanded = !this.competitionExpanded;
    },
    isActive(path) {
      const currentPath =
        this.$route.path === "/" ? "/examination" : this.$route.path;
      if (
        path === "/bookCourse" &&
        [
          "/bookCampusAuth",
          "/bookCourse",
          "/bookTextbook",
          "/bookKnowledge"
        ].includes(currentPath)
      ) {
        return true;
      }
      return currentPath === path;
    },
    goRoute(path) {
      if (this.hasExam && path !== "/examination") {
        this.$message.warning("当前学校正在进行考试，其他功能暂时不可用");
        return;
      }
      if (this.$route.path === path) {
        return;
      }
      this.$router.push(path);
    },
    checkExamStatus() {
      hasExamination()
        .then(res => {
          if (res && (res.code === 200 || res.code === 0)) {
            this.hasExam = res.data === true;
          }
        })
        .catch(err => console.error(err));
    },
    loadStudentInfo() {
      try {
        const uInfoStr =
          window.sessionStorage.getItem("userInfo") ||
          window.localStorage.getItem("userInfo");
        if (uInfoStr) {
          this.localSessionInfo = JSON.parse(uInfoStr);
        }
      } catch (e) {}

      getStudentInfo()
        .then(res => {
          this.infoList = res.data || {};
        })
        .catch(() => {
          this.infoList = {};
        });
    },
    fetchUnreadCount() {
      import("@/api/student").then(({ noReadCount }) => {
        noReadCount()
          .then(res => {
            let resData = res;
            if (typeof resData === "string") {
              try {
                resData = JSON.parse(resData);
              } catch (e) {
                console.error(e);
              }
            }
            if (resData && (resData.code === 200 || resData.code === 0)) {
              this.unreadCount = resData.data || 0;
            }
          })
          .catch(err => console.error(err));
      });
    },
    logout() {
      this.$confirm("确定要退出登录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "premium-confirm"
      })
        .then(() => {
          window.sessionStorage.clear();
          window.localStorage.clear();
          this.$router.push("/login");
          this.$message({
            type: "success",
            message: "已成功退出登录"
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped lang="scss">
$primary-color: #2563eb;
$primary-light: #eff6ff;
$secondary-color: #64748b;
$text-primary: #1e293b;
$bg-color: #f1f5f9;
$sidebar-bg: #ffffff;
$border-color: #e2e8f0;
$font-main: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
  sans-serif;

.page {
  display: flex;
  height: 100vh;
  width: 100%;
  background-color: $bg-color;
  font-family: $font-main;
  overflow: hidden;

  .left {
    width: 260px;
    background-color: $sidebar-bg;
    box-shadow: 1px 0 10px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    padding: 0;
    z-index: 100;
    flex-shrink: 0;
    height: 100vh;
    position: sticky;
    top: 0;
    transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;

    &.is-collapsed {
      width: 80px;
      .logo-section {
        padding: 24px 0;
        justify-content: center;
      }
      .logo-img {
        margin-right: 0;
      }
      .nav-menu .item {
        justify-content: center;
        padding: 12px 0;
        .badge-item {
          margin-right: 0;
        }
      }
      .nav-menu .item i {
        margin-right: 0;
        font-size: 22px;
      }
    }

    .logo-section {
      padding: 24px 20px;
      display: flex;
      align-items: center;
      transition: all 0.3s ease;
      .logo-img {
        width: 24px;
        height: 24px;
        margin-right: 12px;
        flex-shrink: 0;
        transition: margin 0.3s ease;
      }
      .logo-text {
        color: $primary-color;
        font-size: 20px;
        font-weight: 700;
        white-space: nowrap;
        letter-spacing: 0.5px;
      }
    }

    .nav-menu {
      flex: 1;
      padding: 0 16px;
      overflow-y: auto;
    }

    .item {
      display: flex;
      align-items: center;
      text-align: left;
      padding: 12px 16px;
      margin-bottom: 8px;
      border-radius: 10px;
      cursor: pointer;
      color: $secondary-color;
      font-weight: 500;
      font-size: 15px;
      transition: all 0.2s ease;
      white-space: nowrap;

      i {
        width: 20px;
        text-align: center;
        flex-shrink: 0;
        font-size: 20px;
        margin-right: 12px;
        color: #94a3b8;
        transition: color 0.2s;
      }

      &:hover {
        background-color: #f1f5f9;
        color: $primary-color;
        i {
          color: $primary-color;
        }
      }

      &.active {
        background-color: $primary-color;
        color: white;
        box-shadow: 0 4px 12px rgba($primary-color, 0.3);
        i {
          color: white;
        }
      }

      &.disabled-item {
        opacity: 0.5;
        cursor: not-allowed;
        &:hover {
          background-color: transparent;
          color: $secondary-color;
          i {
            color: #94a3b8;
          }
        }
      }

      .badge-item {
        margin-right: 12px;
        display: flex;
        align-items: center;
        ::v-deep .el-badge__content.is-fixed {
          top: 5px;
          right: 5px;
        }
      }

      .badge-after {
        margin-left: 8px;
        display: flex;
        align-items: center;
        ::v-deep .el-badge__content {
          border: none;
        }
      }

      &.logout-item {
        margin-top: 20px;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          top: -10px;
          left: 16px;
          right: 16px;
          height: 1px;
          background: $border-color;
        }
        i {
          color: #f87171;
        }
        &:hover {
          background-color: #fef2f2;
          color: #ef4444;
          i {
            color: #ef4444;
          }
        }
      }
    }

    .menu-group {
      margin-bottom: 8px;

      .parent-item {
        margin-bottom: 4px;
        display: flex;
        align-items: center;
        text-align: left;

        .parent-label {
          flex: 1;
          text-align: left;
        }

        .arrow-icon {
          width: auto;
          margin-left: auto;
          margin-right: 0;
          font-size: 13px;
          transition: transform 0.25s ease;
          color: #94a3b8;
          &.is-rotated {
            transform: rotate(180deg);
          }
        }

        &.group-active {
          color: $primary-color;
          background-color: #f8fafc;
          i {
            color: $primary-color;
          }
        }
      }

      .sub-menu-list {
        padding-left: 12px;
        position: relative;
        margin-bottom: 4px;

        &::before {
          content: "";
          position: absolute;
          left: 24px;
          top: 6px;
          bottom: 6px;
          width: 2px;
          background-color: #e2e8f0;
          border-radius: 1px;
        }

        .sub-item {
          padding: 9px 14px 9px 24px;
          font-size: 14px;
          margin-bottom: 4px;
          border-radius: 8px;
          color: #475569;
          text-align: left;

          i {
            width: 16px;
            text-align: center;
            font-size: 16px;
            margin-right: 10px;
          }

          &:hover {
            background-color: #f1f5f9;
            color: $primary-color;
            i {
              color: $primary-color;
            }
          }

          &.active {
            background-color: $primary-color;
            color: white;
            box-shadow: 0 4px 10px rgba($primary-color, 0.25);
            i {
              color: white;
            }
          }
        }
      }
    }

    .sidebar-footer {
      padding: 20px 16px;
      border-top: 1px solid $border-color;
      .sidebar-user {
        display: flex;
        align-items: center;
        padding: 12px;
        background: #f8fafc;
        border-radius: 12px;
        margin-bottom: 12px;
        .user-avatar {
          width: 36px;
          height: 36px;
          background: $primary-light;
          color: $primary-color;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          margin-right: 10px;
          flex-shrink: 0;
        }
        .user-info {
          overflow: hidden;
          .user-name {
            font-size: 14px;
            font-weight: 700;
            color: $text-primary;
          }
          .user-no {
            font-size: 12px;
            color: $secondary-color;
          }
        }
      }
      .collapse-btn {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        color: #94a3b8;
        font-size: 20px;
        border-radius: 10px;
        transition: background 0.2s;
        &:hover {
          background: #f1f5f9;
          color: $primary-color;
        }
      }
    }
  }

  .right {
    flex: 1;
    height: 100%;
    overflow-y: auto;
    padding: 24px;
    box-sizing: border-box;
    > div {
      margin: 0 auto;
      height: 100%;
    }
  }
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
}
.fade-slide-enter {
  opacity: 0;
  transform: translateY(10px);
}
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>

<style lang="scss">
.el-message {
  border-radius: 12px !important;
  padding: 14px 24px !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
  background-color: rgba(255, 255, 255, 0.75) !important;
  backdrop-filter: blur(12px) saturate(180%) !important;
  -webkit-backdrop-filter: blur(12px) saturate(180%) !important;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  top: 32px !important;

  .el-message__content {
    font-weight: 500;
    font-size: 15px;
  }

  &.el-message--success {
    background-color: rgba(240, 253, 244, 0.8) !important;
    border-color: rgba(74, 222, 128, 0.3) !important;
    .el-message__content {
      color: #166534 !important;
    }
    .el-message__icon {
      color: #22c55e !important;
    }
  }
  &.el-message--error {
    background-color: rgba(254, 242, 242, 0.8) !important;
    border-color: rgba(248, 113, 113, 0.3) !important;
    .el-message__content {
      color: #991b1b !important;
    }
    .el-message__icon {
      color: #ef4444 !important;
    }
  }
  &.el-message--warning {
    background-color: rgba(255, 251, 235, 0.8) !important;
    border-color: rgba(251, 191, 36, 0.3) !important;
    .el-message__content {
      color: #92400e !important;
    }
    .el-message__icon {
      color: #f59e0b !important;
    }
  }
  &.el-message--info {
    background-color: rgba(248, 250, 252, 0.8) !important;
    border-color: rgba(148, 163, 184, 0.3) !important;
    .el-message__content {
      color: #334155 !important;
    }
    .el-message__icon {
      color: #64748b !important;
    }
  }
}
</style>
